import {DeviceHelper} from "./DeviceHelper";
import {PreferencesHelper} from "./PreferencesHelper";

const KEY_JWT = "jwt";
export class JWTHelper {

    static saveJwt(jwt) {
        localStorage.setItem(KEY_JWT, jwt);
    }

    static clearJwt() {
        const preferences = PreferencesHelper.raw();
        localStorage.clear();
        PreferencesHelper.restore(preferences);
    }

    static getJwt() {
        return localStorage.getItem(KEY_JWT);
    }

    static isLoggedIn() {
        return JWTHelper.getJwt() != null
    }
}

